var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPromoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 8l3 3-3 3-3-3 3-3zm-12 2c.983-.979 3 1 3 1s2.017-1.98 3-1c.984.98-1 4-1 4h-4s-1.984-3.021-1-4zm-7 16c0-5.523 4.477-10 10-10s10 4.477 10 10v3s2 1.02 2 2-10.032 1-12 1c-1.967 0-12-.02-12-1s2-2 2-2v-3zm9.77-6H17l-2 3 5 5 5-5-2-3h-3.23zM13 15l-2-2-2 2 2 2 2-2z",
    fill: "#9A9CAC"
  })));
}

export default SvgPromoIcon;